export default __webpack_public_path__ + "static/media/DeleteFacilityIcon.7c9ddba5.svg";